<template>
  <v-dialog
    width="800"
    persistent
    v-model="dialog"
  >
    <v-form @submit.prevent.stop="$canWrite && (submit())">
      <v-card>
        <v-card-title>
          Nouveau chantier
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- <v-toolbar color="primary darken-1" dark>
          <v-toolbar-title>Nouveau chantier</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar> -->
        <v-card-text class="pa-5">
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <v-row justify="center" align="center">
            <v-col>
              <v-text-field v-model="label" label="Nom du chantier*" outlined hide-details required autofocus />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col>
              <v-autocomplete
                :error="autocompleteClientError"
                label="Client*"
                :items="clients"
                v-model="selectedClientId"
                item-value="id"
                item-text="name"
                hide-details
                clearable
                outlined
                :loading="!areClientsFetched"
                append-icon=""
              />
            </v-col>
            <v-btn :disabled="!$canWrite" x-large icon class="mr-3" @click="$canWrite && (isNewClientDialogOpened = true)">
              <v-icon>add</v-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="8">
              <v-menu
                v-model="isStartDateDatePickerOpened"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDateFormatted"
                    label="Date de début*"
                    prepend-inner-icon="today"
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  :allowed-dates="isAllowedDate"
                  @input="isStartDateDatePickerOpened = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="nbDays" type="number" @blur="validateNbDays" min="1" label="Nombre de jours*" outlined hide-details required />
            </v-col>
            <v-col v-if="false">
              <v-menu
                v-model="isEndDateDatePickerOpened"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDateFormatted"
                    label="Date de fin"
                    prepend-inner-icon="today"
                    placeholder="Laisser vide si identique début"
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="isEndDateDatePickerOpened = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col>
              <v-autocomplete
                :error="autocompleteAssigneeError"
                label="Assigné à"
                :items="users"
                v-model="selectedAssigneeId"
                item-value="id"
                item-text="name"
                hide-details
                clearable
                outlined
                :loading="!areUsersFetched"
                append-icon=""
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" v-if="!isSubmitting">Annuler</v-btn>
          <v-btn :disabled="!$canWrite" color="primary darken-1" :loading="isSubmitting" type="submit" depressed>Créer ce chantier</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <new-client-dialog v-model="isNewClientDialogOpened" v-if="isNewClientDialogOpened" @created="newClientCreated" />
  </v-dialog>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
import NewClientDialog from '@/components/NewClientDialog.vue';

export default {
  name: `ProjectModal`,

  props: {
    project: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    isOpened: true,
    label: ``,
    selectedClientId: null,
    startDate: null,
    endDate: null,
    nbDays: 1,
    selectedAssigneeId: null,
    areClientsFetched: false,
    areUsersFetched: false,
    autocompleteClientError: false,
    autocompleteAssigneeError: false,
    isNewClientDialogOpened: false,
    isStartDateDatePickerOpened: false,
    isEndDateDatePickerOpened: false,
    errors: [],
    isSubmitting: false,
  }),

  computed: {
    dialog: {
      get() { return this.isOpened; },
      set(isOpened) {
        this.isOpened = isOpened;
        if (!isOpened) {
          this.$emit(`close`);
        }
      },
    },
    ...mapState(`model/client`, [
      `clients`,
    ]),
    ...mapState(`model/user`, {
      users(state) {
        return state.users.map(user => ({
          ...user,
          name: `${user.firstname} ${user.lastname}`,
        }));
      },
    }),
    startDateFormatted() { return moment(this.startDate, `YYYY-MM-DD`).format(`DD/MM/YYYY`); },
    endDateFormatted: {
      get() {
        if (!this.endDate) { return ``; }

        return moment(this.startDate, `YYYY-MM-DD`).format(`DD/MM/YYYY`);
      },
      set() { this.endDate = null; },
    },
  },

  methods: {
    setStartDate() {
      const startDate = moment();
      if (startDate.day() === 6) {
        startDate.add(2, `days`);
      } else if (startDate.day() === 0) {
        startDate.add(1, `days`);
      }

      this.startDate = startDate.format(`YYYY-MM-DD`);
    },
    async fetchClients() {
      this.areClientsFetched = false;
      await this.$store.dispatch(`model/client/fetchClients`);
      this.areClientsFetched = true;
    },
    async fetchUsers() {
      this.areUsersFetched = false;
      this.$store.dispatch(`ui/projects/fetchUsers`);
      this.areUsersFetched = true;
    },
    newClientCreated(client) {
      this.selectedClientId = client.id;
    },
    isAllowedDate(date) {
      return !_.includes([0, 6], moment(date).day());
    },
    validateNbDays() {
      if (this.nbDays < 1) {
        this.nbDays = 1;
      }
    },
    async submit() {
      this.errors = [];
      if (!this.label || !_.trim(this.label).length) { this.errors.push(`Le nom du chantier est obligatoire`); }
      if (!this.selectedClientId) { this.errors.push(`Le client est obligatoire`); }

      if (this.errors.length) { return; }

      const nbDays = this.nbDays - 1;
      const endDate = moment(this.startDate);
      for (let index = 0; index < nbDays; index += 1) {
        endDate.add(1, `days`);
        if (!this.isAllowedDate(endDate)) {
          endDate.startOf(`isoWeek`).add(1, `week`);
        }
      }

      this.isSubmitting = true;
      await this.$store.dispatch(`model/project/addProjectWithIntervention`, {
        label: this.label,
        Client_id: this.selectedClientId,
        plannedStartAt: this.startDate,
        plannedEndAt: endDate.format(`YYYY-MM-DD`),
        plannedDaysDuration: parseInt(this.nbDays, 10),
        Assignee_id: this.selectedAssigneeId,
      });
      this.isSubmitting = false;
      this.dialog = false;
      this.$emit(`submitted`);
    },
  },

  async beforeMount() {
    this.setStartDate();
    this.fetchClients();
    this.fetchUsers();
  },

  components: {
    NewClientDialog,
  },

};
</script>

<style lang="scss">
</style>
